import { render } from "./ExaminerVideo.vue?vue&type=template&id=b59e68c2"
import script from "./ExaminerVideo.vue?vue&type=script&lang=js"
export * from "./ExaminerVideo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__